function ViewLearner() {
  return (
    <>
      View Learner
    </>
  );
}

export default ViewLearner;
